import { useCallback } from "react";

import useBrazeSDK from "@/hooks/useBrazeSDK";
import useAppMonitor from "@/services/AppMonitor";

interface UseUserIdentitySync {
  resetUserIdentity: () => void;
  syncUserIdentity: (identity: UserIdentity) => void;
}

const useUserIdentitySync = (): UseUserIdentitySync => {
  const { identifyBraze, resetBraze } = useBrazeSDK();
  const { identifyUser: identifyAppMonitorUser } = useAppMonitor();

  const syncUserIdentity = useCallback(
    ({ userId }: UserIdentity) => {
      identifyAppMonitorUser(userId);
      identifyBraze({ userId });
    },
    [identifyBraze, identifyAppMonitorUser],
  );

  const resetUserIdentity = useCallback(() => {
    resetBraze();
  }, [resetBraze]);

  return {
    resetUserIdentity,
    syncUserIdentity,
  };
};

export default useUserIdentitySync;
